import RadioGroup from '@components/molecules/RadioGroup';
import { QuoteType, UserIntent } from '@graphql/generated';
import {
  QuoteInitialForm,
  QuoteTypeFormResult,
} from '@lib/data/typesQuestions';
import GridBox from 'components/atoms/GridBox';
import { FC } from 'react';
import { useForm } from 'react-hook-form';
import styled from 'styled-components';

const Form = styled.form``;

interface Props {
  onSubmit: (data: QuoteTypeFormResult) => void;
  item: QuoteInitialForm;
}

const QuoteTypeForm: FC<Props> = ({ onSubmit, item }) => {
  const { register, handleSubmit, errors } = useForm<{ type: QuoteType }>();

  const onSubmit2 = ({ type }: { type: QuoteType }) => {
    let intent;

    if (item.userIntent === UserIntent.SuhaiLead) intent = UserIntent.SuhaiLead;
    else if (item.userIntent === UserIntent.SuhaiPartner)
      intent = UserIntent.SuhaiPartner;
    else if (type === QuoteType.Renovation) intent = UserIntent.Renovation;

    onSubmit({
      type,
      userIntent: intent,
    });
  };

  return (
    <Form onSubmit={handleSubmit(onSubmit2)}>
      <GridBox justifyContent="center">
        <GridBox width={[1, 0.5, 0.5]}>
          <RadioGroup
            inputRef={register({ required: 'Escolha uma das opções' })}
            errorMessage={errors.type?.message}
            onSelected={(value) => {
              onSubmit2({
                type: value as QuoteType,
              });
            }}
            name="type"
            options={[
              {
                label: 'Sim, já estou segurado',
                value: QuoteType.Renovation,
              },
              {
                label: 'Não, eu não tenho seguro',
                value: QuoteType.New,
              },
            ].map((o) => {
              if (o.value === item.type) return { ...o, checked: true };

              return o;
            })}
          />
        </GridBox>
      </GridBox>
    </Form>
  );
};

export default QuoteTypeForm;
